const localesList = [
  {
    code: 'ar',
    direction: 'rtl',
    name: 'Arabic',
  },
  {
    code: 'de',
    direction: 'ltr',
    name: 'German',
  },
  {
    code: 'en',
    direction: 'ltr',
    name: 'English',
  },
  {
    code: 'fr',
    direction: 'ltr',
    name: 'French',
  },
  {
    code: 'ru',
    direction: 'ltr',
    name: 'Russian',
  },
]

export default localesList
